// Applikator - DEV konfiguracija (`ng build --configuration development`).
// ⚠️ Sve vrijednosti su namjerno prazne. Popuni ih prije deploya na dev.

export const environment = {
  production: false,
  version: '0.0.0',
  timestamp: Date.now(),

  // Relativno: ingress rutira /api/v1 na applikator-backend-service na istom hostu.
  // Zato build ne ovisi o domeni - vrijedi i za IP-only dev i za kasniju domenu.
  apiBaseUrl: '/api/v1',
  // TODO: javni bucket za slike
  bucketBaseUrl: '',
  // Isti OAuth klijent kao backendov GOOGLE_CLIENT_ID - mora se poklapati,
  // jer backend taj ID koristi kao audience pri verifikaciji ID tokena.
  googleClientId: '259347714815-u5f0sve8vmcm7hisi9f8srvsg7l1g8r0.apps.googleusercontent.com',
  // TODO: Facebook App ID
  facebookAppId: '',

  // ── Tracking - kill switch gate-ovi ──
  // D16 (2026-10-15): praćenje na devu radi prije pravnikova odobrenja tekstova, radi provjera (F6); produkcija čeka F5.
  metaPixelId: '1076404282102679', // dev Meta dataset „Applikator – dev” (nikad produkcijski); prazan = Pixel no-op
  ga4MeasurementId: '',           // dev GA4 property još ne postoji; ID tek nakon provjere u followups §7.1 (backend); prazan = no-op
  cookiebotId: '0955374f-bfe7-4446-a356-231202fb2d3a', // grupa applikator.co, dev je besplatni alias (žig „TEST”)
  webEventsEnabled: true,         // vlastita statistika posjeta (FS); tm_visitor tek uz privolu za statistiku

  // PWA: service worker (ngsw) se registrira na rutama aplikacije (/dashboard). Build ga generira
  // (angular.json `serviceWorker` u production i development konfiguraciji).
  pwa: true,
  /**
   * Javni WhatsApp broj Applikatora (npr. „+385 91 …”), samo za gumb „Pošaljite LINK na WhatsApp” na /k kad link
   * ne vrijedi (odluka 144). Prazno = samo uputa da klijent pošalje LINK u postojećem razgovoru.
   */
  whatsappBroj: '',
};
